import { action, makeObservable, observable } from 'mobx';
import { Injectable } from './service.base';
import { IAlertDialog } from '~/views/types';

@Injectable()
export class ForbiddenAlertDialogService {
    @observable public open = true;
    @observable public headerText: string;
    @observable public mainText: string;
    @observable public showContactInfo = true;

    constructor() {
        makeObservable(this);
    }

    @action
    handleOpen = () => {
        this.open = true;
    };

    @action
    handleClose = (authService: any) => {
        //this.open = false;
        authService.setShowForbiddenPopup(false);
    };

    @action
    setData = (data: IAlertDialog) => {
        this.headerText = data.headerText ? data.headerText : '';
        this.mainText = data.mainText ? data.mainText : '';
        this.showContactInfo = data.showContactInfo ? data.showContactInfo : false;
    };
}
